import { styled } from 'buttered';

export let VerticalCenter = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;
